import { render } from "./top-products.vue?vue&type=template&id=18c39fb7&scoped=true"
import script from "./top-products.vue?vue&type=script&lang=js"
export * from "./top-products.vue?vue&type=script&lang=js"

import "./top-products.vue?vue&type=style&index=0&id=18c39fb7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18c39fb7"]])

export default __exports__